import contract from '../generated/catalog-contract.json';

export const BALANCE_PAYMENT_NOTE = contract.deposit_policy.balance_payment_note;
export const isPhotoDeposit = service => Boolean(service && service.slug !== 'mini-noel-2026' && contract.deposit_policy.photo_categories.includes(service.category));
export const depositFor = (service, total = service?.price_chf || 0) => {
  if (!service) return 0;
  return isPhotoDeposit(service)
    ? Math.round(Number(total) * service.deposit_pct) / 100
    : Math.floor(Number(total) * service.deposit_pct / 100);
};
export const paymentAmount = value => Number(value || 0).toFixed(2);